import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SharedModule } from "./shared/modules/shared.module";
import { MaterialModule } from "./shared/modules/material.module";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { DatePipe } from "@angular/common";
import { AngularFireModule } from "@angular/fire/compat";
import { AngularFireAuthModule } from "@angular/fire/compat/auth";
import { environment } from "src/environments/environment";
import { WithdrawalRequestReceivedModalComponent } from "./shared/components/withdrawal-request-received-modal/withdrawal-request-received-modal.component";
@NgModule({
  declarations: [AppComponent, WithdrawalRequestReceivedModalComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule,
    SharedModule,
    MaterialModule,
  ],
  providers: [DatePipe, provideHttpClient(withInterceptorsFromDi())],
})
export class AppModule {}
